import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ImageUploadResponse, Image } from '../models/image.model';

/**
 * Загрузка изображений на backend.
 *
 * Контракт:
 *   - `POST ${environment.apiUrl}/includes/images/upload/`
 *   - multipart/form-data, файлы под ключом `files`
 *   - 201 → `{ images: RentalImage[], errors: { name, error }[] }`
 *   - 400 → если файлов нет
 *
 * `Content-Type` НЕ выставляем вручную — `HttpClient` сам подставит
 * `multipart/form-data; boundary=...`, иначе сломается boundary.
 * JWT-токен подставляет `authInterceptor` (см. `core/auth/auth.interceptor.ts`).
 */
@Injectable({ providedIn: 'root' })
export class ImageService {
  private readonly apiUrl = `${environment.apiUrl}/includes/images/upload/`;
  private readonly http = inject(HttpClient);

  /**
   * Загрузить список файлов на backend.
   * Возвращает только успешно загруженные `RentalImage`. Ошибки отдельных
   * файлов доступны в полном ответе — если потребуется, можно завести
   * второй метод, возвращающий весь `ImageUploadResponse`.
   */
  upload(files: File[]): Observable<Image[]> {
    const formData = new FormData();
    for (const f of files) {
      formData.append('files', f, f.name);
    }
    return this.http
      .post<ImageUploadResponse>(this.apiUrl, formData)
      .pipe(map((res) => res.images ?? []));
  }
}
